import React, { Component } from "react";
import { appName } from "../../../app.json";
import { Helmet } from "react-helmet";
import ActivePage from "../../../partials/active-page";
import WardList from "./partials/WardList.jsx";
import NewWardForm from "./partials/NewWardForm";
import { Query, Mutation } from "react-apollo";
import { NEW_WARD, GET_WARD, NEW_ROOM, NEW_BED } from "../../../queries/ward.query";
import auth from "../../../providers/Auth.Provider";
import { Redirect } from "react-router-dom";
import LoadingSpinner from "../../../partials/loading";
import AlertMessage from "../../../partials/alertMessage";
import RoomListItems from "./Room/ListItem.jsx";
import NewRoomForm from "./Room/NewRoomForm.jsx";
import NewBedForm from "./Bed/NewbedForm.jsx";

class Ward extends Component {
    state = {
        page: 1,
        limit: 100,
        ward: null,
        newBed: false,
        newRoom: false,
        room: null,
    };
    render() {
        const { GetToken, GetAuthenticatedStaff } = auth.authProvider;
        if (!GetToken()) {
            return (
                <Redirect
                    to={{
                        pathname: "/login",
                        search: `?redirect=${this.props.location.pathname}`,
                    }}
                />
            );
        }
        const { site } = GetAuthenticatedStaff();
        const { page, limit } = this.state;
        const title = "Ward, Room and Bed";
        const pages = [{ title, path: this.props.match.path }];
        return (
            <>
                <Helmet>
                    <title>
                        {title} | {appName}
                    </title>
                    <link href="../main/css/inbox.min.css" rel="stylesheet" type="text/css" />
                </Helmet>
                <ActivePage title={title} pages={pages} />
                <div className="row justify-content-center">
                    {/* Ward */}
                    <div className="col-md-6">
                        <div className="card">
                            <div className="card-head">
                                <header>Ward Management</header>
                                <div className="tools">
                                    <a className="t-collapse btn-color fa fa-chevron-down" href="javascript:;"></a>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-12">
                                        <h5>New Ward Form</h5>
                                        <Mutation
                                            mutation={NEW_WARD}
                                            update={(caches, { data: { NewWard } }) => {
                                                const { GetWards } = caches.readQuery({
                                                    query: GET_WARD,
                                                    variables: { site: site.id, page, limit },
                                                });
                                                GetWards.docs.unshift(NewWard.doc);
                                                caches.writeQuery({
                                                    data: { GetWards },
                                                    query: GET_WARD,
                                                    variables: { site: site.id, page, limit },
                                                });
                                            }}
                                        >
                                            {(CreateWard, { loading, error }) => (
                                                <>
                                                    {loading && <LoadingSpinner loading={loading} />}
                                                    <AlertMessage message={error && error.message} failed={true} />
                                                    <NewWardForm
                                                        onSubmit={async ({ name, desc }) => {
                                                            await CreateWard({
                                                                variables: { name, site: site.id, desc },
                                                            });
                                                        }}
                                                    />
                                                </>
                                            )}
                                        </Mutation>
                                    </div>
                                    <div className="col-md-12">
                                        <hr />
                                        <h5>List of Ward</h5>
                                        <Query query={GET_WARD} variables={{ page, limit, site: site.id }}>
                                            {({ data, loading, error }) => {
                                                return (
                                                    <>
                                                        <LoadingSpinner loading={loading} />
                                                        <AlertMessage message={error && error.message} failed={true} />
                                                        <AlertMessage message={data && data.GetWards.docs.length < 1 && "No record found!"} failed={true} />
                                                        {data && <WardList onSelected={this.updateWard} items={data.GetWards.docs} />}
                                                    </>
                                                );
                                            }}
                                        </Query>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Room */}
                    {this.state.ward && (
                        <div className="col-md-6">
                            <div className="row justify-content-center">
                                {/* New Bed */}
                                {this.state.newBed && (
                                    <div className="col-md-12 fade-in">
                                        <div className="card">
                                            <div className="card-head">
                                                <header>
                                                    <span className="text-muted">{this.state.room.name}</span> <i className="fa fa-angle-right"></i> <span className="text-success">New Bed Form</span>
                                                </header>
                                            </div>
                                            <div className="card-body">
                                                <Mutation mutation={NEW_BED}>
                                                    {(NewBed, { loading, error, data }) => (
                                                        <>
                                                            {loading && <LoadingSpinner loading={loading} />}
                                                            <AlertMessage message={error && error.message} failed={true} />
                                                            <AlertMessage message={data && data.NewBed.message} failed={false} />
                                                            <NewBedForm
                                                                onCancel={() =>
                                                                    this.setState({
                                                                        newBed: false,
                                                                    })
                                                                }
                                                                onSubmit={async ({ name, desc }) => {
                                                                    await NewBed({
                                                                        variables: {
                                                                            room: this.state.room.id,
                                                                            name,
                                                                            desc,
                                                                        },
                                                                    });
                                                                }}
                                                            />
                                                        </>
                                                    )}
                                                </Mutation>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {this.state.newRoom && (
                                    <div className="col-md-12 fade-in">
                                        <div className="card">
                                            <div className="card-head">
                                                <header>
                                                    {" "}
                                                    <span className="text-muted">{this.state.ward.name} </span>
                                                    <i className="fa fa-angle-right"></i> <span className="text-success">New Room Form</span>
                                                </header>
                                            </div>
                                            <div className="card-body">
                                                <Mutation
                                                    mutation={NEW_ROOM}
                                                    update={(caches, { data: { NewRoom } }) => {
                                                        const { GetWards } = caches.readQuery({
                                                            query: GET_WARD,
                                                            variables: {
                                                                site: site.id,
                                                                page,
                                                                limit,
                                                            },
                                                        });
                                                        const index = GetWards.docs.findIndex((c) => c.id === this.state.ward.id);
                                                        GetWards.docs[index].rooms.unshift(NewRoom.doc);
                                                        caches.writeQuery({
                                                            data: { GetWards },
                                                            query: GET_WARD,
                                                            variables: {
                                                                site: site.id,
                                                                page,
                                                                limit,
                                                            },
                                                        });
                                                    }}
                                                >
                                                    {(NewRoom, { loading, error, data }) => (
                                                        <>
                                                            {loading && <LoadingSpinner loading={loading} />}
                                                            <AlertMessage message={error && error.message} failed={true} />
                                                            <AlertMessage message={data && data.NewRoom.message} failed={false} />
                                                            <NewRoomForm
                                                                onCancel={() =>
                                                                    this.setState({
                                                                        newRoom: false,
                                                                    })
                                                                }
                                                                onSubmit={async ({ name, desc }) => {
                                                                    await NewRoom({
                                                                        variables: {
                                                                            ward: this.state.ward.id,
                                                                            name,
                                                                            desc,
                                                                        },
                                                                    });
                                                                }}
                                                            />
                                                        </>
                                                    )}
                                                </Mutation>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <div className="col-md-12 fade-in">
                                    <div className="card">
                                        <div className="card-head">
                                            <header className="fade-in">
                                                <span className="text-muted">{this.state.ward.name} </span>
                                                <i className="fa fa-angle-right"></i>
                                                <span className="text-success">Rooms </span>
                                                <span className="mdl-badge" data-badge={this.state.ward.rooms.length}></span>
                                            </header>
                                            <div className="tools">
                                                <button
                                                    title="New Room"
                                                    onClick={() => {
                                                        this.setState({ newRoom: true });
                                                        document.body.scrollTop = 0;
                                                        document.documentElement.scrollTop = 0;
                                                    }}
                                                    className="mdl-button mdl-js-button btn-success mdl-button--icon margin-right-10"
                                                    data-upgraded=",MaterialButton"
                                                >
                                                    <i className="material-icons">add</i>
                                                </button>
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            <RoomListItems
                                                onNewBed={(item) => {
                                                    this.setState({
                                                        room: item,
                                                    });
                                                    this.setState({ newBed: true });
                                                    document.body.scrollTop = 0;
                                                    document.documentElement.scrollTop = 0;
                                                }}
                                                items={this.state.ward.rooms}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </>
        );
    }
    updateWard = (ward) => {
        this.setState({ ward });
    };
}

export default Ward;
